import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import formatIntegerBySpace from '../../../../../../helpers/formatters/format-integer-by-space'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'

interface CopiesProps {}

const Copies: FC<CopiesProps> = () => {
    const ctx = useContext(EditableCellCtx)

    return (
        <Form.Item name={'copies'} noStyle>
            <InputNumber
                autoFocus
                // step={1000}
                formatter={formatIntegerBySpace}
                controls={false}
                onBlur={() => {
                    ctx.onBlur()
                }}
            />
        </Form.Item>
    )
}

export default Copies
